import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-teal-50 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center text-teal-600 hover:text-teal-700 mb-6">
          <ArrowLeft className="w-4 h-4 mr-1" /> Back to Home
        </Link>
        
        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">Terms and Conditions</CardTitle>
            <p className="text-slate-500">Eswatini Seals Swim Academy</p>
          </CardHeader>
          <CardContent className="prose prose-slate max-w-none">
            <p className="text-sm text-slate-500">Last updated: January 2026</p>
            
            <h2 className="text-lg font-semibold mt-6 mb-3">1. Acceptance of Terms</h2>
            <p>
              By registering for any program offered by Eswatini Seals Swim Academy, you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not proceed with registration.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-3">2. Program Registration</h2>
            <p>
              Registration for our swimming programs is subject to availability. We reserve the right to modify class schedules, instructors, and locations as needed to ensure the quality of our programs.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-3">3. Payment Terms</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>All fees must be paid prior to the commencement of the program</li>
              <li>Prices are quoted in Eswatini Lilangeni (SZL/E)</li>
              <li>For school programs, bulk discounts may apply as specified during registration</li>
              <li>Payment plans may be available for qualifying institutions</li>
            </ul>

            <h2 className="text-lg font-semibold mt-6 mb-3">4. Cancellation and Refund Policy</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Cancellations made 14 days or more before program start: Full refund</li>
              <li>Cancellations made 7-13 days before program start: 50% refund</li>
              <li>Cancellations made less than 7 days before program start: No refund</li>
              <li>Missed lessons due to student absence are non-refundable</li>
            </ul>

            <h2 className="text-lg font-semibold mt-6 mb-3">5. Safety and Conduct</h2>
            <p>
              All participants must follow safety rules and instructions provided by our certified instructors. The Academy reserves the right to remove any participant who endangers themselves or others.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-3">6. Health Requirements</h2>
            <p>
              Participants must be in good health and free from contagious conditions. Parents/guardians must inform us of any medical conditions that may affect participation.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-3">7. Liability</h2>
            <p>
              While we take every precaution to ensure safety, participation in swimming activities carries inherent risks. By registering, you acknowledge these risks and release Eswatini Seals Swim Academy from liability for injuries that may occur during normal program activities.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-3">8. Photo/Video Consent</h2>
            <p>
              We may take photographs or videos during lessons for promotional purposes. If you do not wish to be included, please inform us in writing.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-3">9. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time. Continued participation in our programs constitutes acceptance of any changes.
            </p>

            <h2 className="text-lg font-semibold mt-6 mb-3">10. Contact Information</h2>
            <p>
              For questions about these terms, please contact us at:<br />
              Email: info@eswatiniseals.com<br />
              Phone: +268 7xxx xxxx
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TermsAndConditions;
